import type { ResultOf } from '@graphql-typed-document-node/core';

import { query } from '../../common/requests/base.query.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const ME_QUERY = query({
  me: {
    parent: {
      preferredName: true,
    },
  },
});

type MeResponseType = ResultOf<typeof ME_QUERY>['me'];

export const meQueryRequest = async (): Promise<ResultType<MeResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.query(ME_QUERY, {}, ['me'], { useAuth: true });

    return {
      success: true,
      data: response?.me ?? {},
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
